import React from 'react'
import { Grid } from '@material-ui/core'
import CardHit from 'modules/search/components/Widgets/CustomCardHit'
import { Book } from 'modules/search/types'

type PropTypes = {
  hits: Book[]
  indexContextValue?: {
    targetedIndex?: string
  }
}

const Hits = (props: PropTypes) => {
  const { hits }: { hits: Book[] } = props
  return (
    <Grid container direction="row" spacing={3}>
      {hits.map((hit: Book) => (
        <CardHit key={hit.objectID} hit={hit} index={props.indexContextValue} />
      ))}
    </Grid>
  )
}

const areEqual = (props: PropTypes, nextProps: PropTypes) => {
  return JSON.stringify(props) === JSON.stringify(nextProps)
}

export default React.memo(Hits, areEqual)
